<template>
  <div class="userBox">
    <div class="userTab">
      <div class="userTabItem"
           :class="{userTabBorder: type !== 0 && type !== 1, userTabActive: type === 0}"
           @click="toPage('/org/userInfo/orgInfo', 0)"
      >机构信息</div>
      <div class="userTabItem"
           :class="{userTabBorder: type !== 1 && type !== 2, userTabActive: type === 1}"
           @click="toPage('/org/userInfo/accountInfo', 1)"
           v-if="is_execute!==1"
      >帐户信息</div>
<!--      <div class="userTabItem"-->
<!--           :class="{userTabBorder: type !== 2 && type !== 3, userTabActive: type === 2}"-->
<!--           @click="toPage('/org/userInfo/orgVip', 2)"-->
<!--      >开通会员</div>-->
      <div class="userTabItem"
           :class="{ userTabActive: type === 3}"
           @click="toPage('/org/userInfo/orgHelp', 3)"
      >帮助中心</div>

    </div>
    <router-view class="userContent" @setType="setType"/>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        type: 0,
        is_execute: 0,
      }
    },
    computed: {},
    created() {
      this.is_execute = this.$store.state.user.is_execute
    },
    methods: {
      // 跳转页面
      toPage(router, index) {
        this.$router.replace(router)
        this.type = index
      },
      setType(type) {
        this.type = type
      }
    },
    components: {}
  }
</script>

<style scoped lang="scss">
  .userBox {
    width: 100%;
    height: 100%;
    overflow: hidden;
    background: rgba(244, 246, 249, 1);

    .userTab {
      width: 1200px;
      height: 48px;
      margin: 21px auto 0 auto;
      border-bottom: 4px #00a2ea solid;
      background: #ffffff;
      display: flex;
      justify-content: flex-start;
      align-items: flex-end;
      padding-left: 78px;

      .userTabItem {
        width: 133px;
        height: 34px;
        text-align: center;
        line-height: 34px;
        cursor: pointer;
      }

      .userTabBorder {
        /*border-right: 1px #cccccc solid;*/
        /*margin-bottom: 4px;*/
        /*height: 30px;*/
        /*line-height: ;*/
        position: relative;

        &:after {
          position: absolute;
          top: 7px;
          right: 0;
          content: '';
          width: 1px;
          height: 20px;
          background: #ccc;
        }
      }

      .userTabActive {
        background-color: #00a2ea;
        color: #ffffff;
      }
    }

    .userContent {
      width: 1200px;
      margin: 0 auto 39px auto;
      min-height: 500px;
      /*background: #ffffff;*/
      overflow: hidden;
    }
  }
</style>